export default [
  {
    path: '/topics/:categoryId/:topicId/:subtopicId?',
    name: 'topics#show',
    component: () => import('@views/topics/show'),
    meta: {
      footer: true,
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/topics/:categoryId?',
    name: 'topics#index',
    component: () => import('@views/topics/index'),
    meta: {
      header: true,
    },
  },
];
